'use client';

import {
  FeatureItem,
  FileTypeConfig,
  LandingFeatures,
  LandingHero,
  LandingUseCases,
} from '../_components';
import { BarChart3, Calculator, Layers, Lock, Sheet } from 'lucide-react';

const xlsxConfig: FileTypeConfig = {
  type: 'xlsx',
  title: '在线翻译 Excel 表格·公式函数零误差',
  subtitle: '科研数据、业务分析的智能助手专业翻译',
  description: '智能识别并保留所有计算公式',
  icon: <Sheet className="w-full h-full" />,
  gradientFrom: '#10b981',
  gradientTo: '#059669',
  accentColor: 'emerald',
  particleColors: ['#10b981', '#34d399', '#6ee7b7'],
  accept: {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
      '.xlsx',
    ],
  },
  stats: {
    users: '50万+',
    accuracy: '99.8%',
    files: '200万+',
  },
};

const xlsxFeatures: FeatureItem[] = [
  {
    icon: Lock,
    title: '公式保护',
    description: 'SUM/VLOOKUP 等 500+ 函数完整保留',
  },
  {
    icon: Layers,
    title: '多工作表处理',
    description: '批量翻译整个工作簿，所有 Sheet 一次搞定',
  },
  {
    icon: BarChart3,
    title: '图表保留',
    description: '数据可视化图表、数据透视表完整保持',
  },
  {
    icon: Calculator,
    title: '单元格格式',
    description: '数字、日期、条件格式精准还原',
  },
];

const xlsxUseCases = [
  '科研数据集',
  '销售数据',
  '库存管理',
  '财务报表',
  '临床试验',
  '市场分析',
];

const XlsxPage = () => {
  return (
    <div className="w-full">
      <LandingHero config={xlsxConfig} />
      <LandingFeatures
        title="Excel 技术亮点"
        features={xlsxFeatures}
        gradientFrom={xlsxConfig.gradientFrom}
        gradientTo={xlsxConfig.gradientTo}
      />
      <LandingUseCases
        useCases={xlsxUseCases}
        gradientFrom={xlsxConfig.gradientFrom}
        gradientTo={xlsxConfig.gradientTo}
      />
    </div>
  );
};

export default XlsxPage;
